import React from 'react';
import { Button } from 'antd';
import { FuelReceipt } from '../../types';

interface FuelReceiptModalFooterProps {
  t: (key: string) => string;
  isMobile: boolean;
  editingReceipt: FuelReceipt | null;
  onCancel: () => void;
  onSaveAsDraft: () => void;
  onCreate: () => void;
}

const FuelReceiptModalFooter: React.FC<FuelReceiptModalFooterProps> = ({
  t,
  isMobile,
  editingReceipt,
  onCancel,
  onSaveAsDraft,
  onCreate
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: isMobile ? 'column' : 'row',
      gap: '8px',
      justifyContent: 'flex-end'
    }}>
      <Button onClick={onCancel} style={{ order: isMobile ? 3 : 1 }}>
        {t('cancel')}
      </Button>
      <Button onClick={onSaveAsDraft} style={{ order: isMobile ? 2 : 2 }}>
        {editingReceipt ? t('save.as.draft') : t('save')}
      </Button>
      <Button type="primary" onClick={onCreate} style={{ order: isMobile ? 1 : 3 }}>
        {editingReceipt ? t('update.receipt') : t('create.fuel.receipt')}
      </Button>
    </div>
  );
};

export default FuelReceiptModalFooter;
